<template>
	<div
		class="customer-assignation__item-template"
		:class="[
			isFlyout
				? 'customer-assignation__item-template--manage-customers'
				: 'customer-assignation__item-template--pre-assign-customers'
		]"
	>
		<Checkbox
			:displayLabel="true"
			:id="`${uid}_checbox`"
			:labelText="`(${customerData.description}) ${customerData.text}`"
			:name="`${uid}_checbox`"
			:value="customerData.value"
			@input="changeModelValue"
		/>
		<span
			class="customer-assignation__enablement-options"
			v-if="customerData.modelValue"
		>
			<RadioButtonGroup
				:id="`${uid}_rbgroup`"
				:items="radioButtonItems"
				:name="`${uid}_checbox`"
				v-model="customerData.enabled"
			/>
		</span>
	</div>
</template>

<script>
import RadioButtonGroup from '@/components/forms/selection-control/radiobutton/radiobutton-group';
import Checkbox from '@/components/forms/selection-control/checkbox/checkbox';

export default {
	name: 'CustomerAssignationItem',
	components: {
		Checkbox,
		RadioButtonGroup
	},
	props: {
		customer: {
			type: Object,
			required: true
		},
		isFlyout: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			customerData: this.customer,
			radioButtonItems: [
				{
					labelText: 'Enable',
					value: true
				},
				{
					labelText: 'Disable',
					value: false
				}
			]
		};
	},
	methods: {
		changeModelValue(val, isSelected) {
			this.customerData.modelValue = isSelected ? val : '';
		}
	},
	watch: {
		customerData: {
			deep: true,
			handler(val) {
				this.$emit('change', val);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.customer-assignation__enablement-options {
	display: flex;
	margin-left: $gutter-xl;
}

/*------------------------------------*\
  #PRE-ASSIGN CUSTOMERS
  Only visible on the Impact and Laser Form Designer prior to first Publish
\*------------------------------------*/
@import '@/scss/5-objects/_cards.scss';

.customer-assignation__item-template--pre-assign-customers {
	@include card;
	display: flex;
	padding: $padding-md;
	justify-content: space-between;
	align-items: center;

	@include mq($until: md) {
		flex-wrap: wrap;
		> * {
			width: 100%;
		}
		.customer-assignation__enablement-options {
			margin-top: $gutter-md;
		}
	}
}

/*------------------------------------*\
  #MANAGE CUSTOMERS
  Displayed in a flyout component accessible from Global Form Manager Card and Form Designer
\*------------------------------------*/
.customer-assignation__item-template--manage-customers {
	display: grid;
	gap: $gutter-lg;
	padding: $padding-xs; // aligns with mock and needed to account for focus style of checkbox
}
</style>
